import React, { Component } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth, scrollToTopValidate } from "../Helpers/SettingHelper";
import { apiUrl} from'../Config/Config';
import axios from 'axios';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };
class Add extends Component {
	
	fileObj = [];
    fileArray = [];
    imageArray = [];
	
	constructor(props)
	{
		CheckAuth();
		super(props);	
		this.state = {
			trip_count:'',			
			reward_amount:'',			
			reward_miles:'',			
			status:'',		    
			description: '',
			Loading:false,
			selectedvalue: '',
            selectedOption:{ value: 'active', label: 'Active'},
			
			selRewardTypeVal: "normal",
            selRewardTypeOption:{ value: 'normal', label: 'Normal'},
		};
		
	   this.handleInputChange = this.handleInputChange.bind(this);
	   this.handleChange = this.handleChange.bind(this);
    }
	

   handleInputChange(event) {

      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
    }

	// handleChange = selectedOption => {
	// 	this.setState({selectedOption})
    //     this.setState({  selectedvalue : selectedOption.value});
    // };	
	handleChange = (r,selOption) => {        
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}else if(r == 'rewardType'){			
			this.setState({selRewardTypeOption:selOption})
			this.setState({  selRewardTypeVal : selOption.value});
		}
    };
	componentDidMount() {
		document.title = PageTitle('Bonus Add');
    }

  /*onFileChange = event => { 
     
      // Update the state 
      this.setState({ selectedFile: event.target.files[0] }); 
	  
	  this.fileObj = [];
        this.fileObj.push(e.target.files)
        for (let i = 0; i < this.fileObj[0].length; i++) {
            this.fileArray.push(URL.createObjectURL(this.fileObj[0][i]))
            //this.fileArray.push(this.fileObj[0][i])
            this.imageArray.push(this.fileObj[0][i])

        }
        this.setState({ font_file: this.imageArray })	
		
     
    }; */
	
	onFileChange = (e) =>{
	this.fileObj = [];
        this.fileObj.push(e.target.files)
        for (let i = 0; i < this.fileObj[0].length; i++) {
            this.fileArray.push(URL.createObjectURL(this.fileObj[0][i]))
            //this.fileArray.push(this.fileObj[0][i])
            this.imageArray.push(this.fileObj[0][i])

        }
        this.setState({ font_file: this.imageArray })		
    }

/*  onChangeHandler=event=>{
    let reader = new FileReader();
    const file = event.target.files[0];
    reader.onloadend = () => {
      this.setState({
        user_image_name: file.name,
        user_image_preview: reader.result,
        image: file
      });
    };
    reader.readAsDataURL(file);
  }*/

	 handleFormSubmit = () => {
			if(this.validateForm()){
				this.setState({Loading:true});
				 const config = {
			        headers: {
			          'Content-Type': 'multipart/form-data'
			        }
			      };

				const formPayload = this.state;
				var qs = require('qs');
				var status = '';
				var discountType = '';
				if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
				status =formPayload.selectedOption.value;
				}else{
				status = formPayload.selectedvalue;
				}				
				var admin_id = localStorage.getItem("admin_id");
				var postObject = {
					admin_id     : admin_id,
					trip_count    : formPayload.trip_count,
					reward_amount    : formPayload.reward_amount,
					reward_miles    : formPayload.reward_miles,
					reward_type : formPayload.selRewardTypeVal,
					description : formPayload.description,
					status       : status,
				};

				let formData = new FormData();
				for(let k in postObject) {
				formData.append(k, postObject[k]);
				}
				
				// var filesdata = this.state.font_file;
				
				// for (var i in filesdata) {
				//  formData.append('font_file[]',filesdata[i])
				// }	
				
				
				axios.post(apiUrl+"bonusmanagement/add",formData,config).then(res => {
					
					if(res.data.status === "success"){
						this.setState({ Loading: false });
						$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');


								setTimeout(
								function() {
									$('.success_message').html('');
									this.props.navigate('/bonusManagement');
								}
								.bind(this),
								3000
								);
					} else {
						this.setState({ Loading: false });
						$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
							setTimeout(
							function() {
								$('.success_message').html('');
							}
							.bind(this),
							3000
							);
					}
				});
			}
	}

	validateForm() {

		const {trip_count,reward_amount, selRewardTypeVal, reward_miles} = this.state;
		const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
		let errors = 0;
	
		if (!trip_count) {
			errors++;
			$('.errortrip_count').html('<span class="errorspan">Please enter the trip count</span>');
		}else if(trip_count){
			$('.errortrip_count').html('');
		}
		
		if (!reward_amount) {
			errors++;
			$('.errorreward_amount').html('<span class="errorspan">Please enter reward amount</span>');
		}else if(reward_amount){
			$('.errorreward_amount').html('');
		}
		
		if (!selRewardTypeVal || selRewardTypeVal.trim() === "") {
			errors++;
			$(".errorRewardType").html('<span class="errorspan">Please select the type</span>');
		} else {
			$(".errorRewardType").html('');
		}


		if (!reward_miles) {
			errors++;
			$('.errorreward_miles').html('<span class="errorspan">Please enter miles</span>');
		}else if(reward_miles){
			$('.errorreward_miles').html('');
		}
		
		if(errors>0) {
		setTimeout(function () {
		scrollToTopValidate();
		}, 100);
		return false;
		}
		else {
		return true;
		}

		/*this.setState({
			errors: errors
		});
		return formIsValid;*/
    }

    componentWillReceiveProps(Props){

      }

	handleDateChange = (e) => {
		const {name, value} = e.target;      
		//console.log(name, value, "--handleDateChange");
		this.setState({
			[name]: value
		});
	};

  render() {
  	const {selectedOption, selRewardTypeOption,discountType, startDate, endDate,description, discountSel} = this.state;


    return (
      <div className="wrapper"> 
 
	  <Header />
    <MenuSidebar currentpage="bonusManagement"  currentTab="car" />  

	<div className="content">	
		<div className="content-wrapper">
				  <div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">

			<div className="success_message"></div>
			<div>
				<a class="primary-btn" href="/bonusManagement">Back</a>
			</div>
			<div className="title">
				<h4>Add Bonus Reward</h4>
			</div>
		<form className="login" id="login" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }}>
			<div className="form-row">
			   <div className="form-left">
		    	<div className="form-group">
					<label>Trip Counts<span class="required" style={{ color: "red" }} >*</span></label>
				    <input type="text" name="trip_count" onChange={this.handleInputChange} className="form-control" value={this.state.trip_count} autoComplete="off" />
					<div className="errortrip_count"></div>
				</div>
				<div className="form-group">					
					<label>Reward Type <span class="required" style={{ color: "red" }} >*</span></label>
					<Select 
					value={selRewardTypeOption?selRewardTypeOption:{ value: 'normal', label: 'Normal'}}
					options={lang.common.rewardTypeOption} 
					onChange={this.handleChange.bind(this, 'rewardType')}
					/>
					<div className="errorRewardType"></div>
				</div>
				<div className="form-group">
					<label>Description</label>					
					<CKEditor
						editor={ ClassicEditor }
						data={this.state.description}
						onReady={ editor => {
							// You can store the "editor" and use when it is needed.
							console.log( 'Editor is ready to use!', editor );
							editor.ui.view.editable.element.style.minHeight = "300px";
						} }
						name="description"
						// onChange={this.handleInputChange}
						onChange={ ( event, editor ) => {
							const data = editor.getData();
							this.setState({description: data});
							editor.ui.view.editable.element.style.minHeight = "300px";
						} }
					/>
					<div className="errordescription"></div>
				</div>
			</div>				
			<div className="form-right">				  
				<div className="form-group">
					<label>Reward Amount ($) <span class="required" style={{ color: "red" }} >*</span></label>					
					<input type="text" name="reward_amount" onChange={this.handleInputChange} className="form-control" value={this.state.reward_amount} autoComplete="off" />
					<div className="errorreward_amount"></div>
				</div>
				<div className="form-group">
					<label>Miles <span class="required" style={{ color: "red" }} >*</span></label>					
					<input type="text" name="reward_miles" onChange={this.handleInputChange} className="form-control" value={this.state.reward_miles} autoComplete="off" />
					<div className="errorreward_miles"></div>
				</div>
				<div className="form-group">					
					<label>Status</label>
					<Select 
					value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
					options={lang.common.status_option} 
					onChange={this.handleChange.bind(this, 'status')}
					/>
				</div>
			 	
				
			</div>
			</div>		

			<div className="btn-group export">	
				   <button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true &&
                                        <span className="load-data"></span> 
                                        }Submit
                   </button>
			</div>
			</form>
			</div>
				
		</div>	
	</div>
		 	
    </div>
    );
  }
}



export default withRouter(Add);